const KEY = "munchi-auth-token";

export function getToken(): string | null {
  if (typeof window === "undefined") return null;
  return localStorage.getItem(KEY);
}

export function setToken(value: string) {
  const bearer = value.startsWith("Bearer ") ? value : `Bearer ${value}`;
  localStorage.setItem(KEY, bearer);
}

export function clearToken() {
  localStorage.removeItem(KEY);
}

export function logout() {
  clearToken();
  localStorage.removeItem("munchi-auth");
  localStorage.removeItem("munchi-user");
  localStorage.removeItem("munchi-guest");
  sessionStorage.removeItem("munchi-last-order");
  sessionStorage.removeItem("munchi-last-order-slug");
}

export function hasToken(): boolean {
  return !!getToken();
}
